export default "__VITE_ASSET__36TwICZB__"